import { UIText3 } from '@cian/ui-kit';
import {
  IconToggleStarOff24,
  IconActionStarCrossed24,
  IconActionDelete24,
  IconActionOpenFolderLine24,
  IconActionMessageLine24,
  IconActionMessageUnread24,
  IconActionUnfolder24,
  IconActionUserUnblock24,
} from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './ChatListItemSwipeButton.css';

export enum EChatListItemSwipeButtonType {
  Archive = 'archive',
  Delete = 'delete',
  Read = 'read',
  Return = 'return',
  Unblock = 'unblock',
  Unread = 'unread',
  Starred = 'starred',
  Unstarred = 'unstarred',
}

type TButtonInfo = {
  text: string | React.ReactNode;
  color: string;
  image: React.ReactElement;
};

const ButtonsInfo: { [key in EChatListItemSwipeButtonType]: TButtonInfo } = {
  [EChatListItemSwipeButtonType.Archive]: {
    text: 'В архив',
    image: <IconActionOpenFolderLine24 color={'icon-inverted-default'} />,
    color: 'var(--theme-gray)',
  },
  [EChatListItemSwipeButtonType.Delete]: {
    text: 'Удалить',
    image: <IconActionDelete24 color={'icon-inverted-default'} />,
    color: 'red',
  },
  [EChatListItemSwipeButtonType.Read]: {
    text: 'Прочитано',
    image: <IconActionMessageLine24 color={'icon-inverted-default'} />,
    color: 'var(--theme-green)',
  },
  [EChatListItemSwipeButtonType.Starred]: {
    text: 'Важное',
    image: <IconToggleStarOff24 color={'icon-inverted-default'} />,
    color: 'blue',
  },
  [EChatListItemSwipeButtonType.Return]: {
    text: 'Вернуть',
    image: <IconActionUnfolder24 color={'icon-inverted-default'} />,
    color: 'var(--theme-gray)',
  },
  [EChatListItemSwipeButtonType.Unblock]: {
    text: 'Разблокировать',
    image: <IconActionUserUnblock24 color={'icon-inverted-default'} />,
    color: 'var(--theme-gray)',
  },
  [EChatListItemSwipeButtonType.Unread]: {
    text: 'Не прочитано',
    image: <IconActionMessageUnread24 color={'icon-inverted-default'} />,
    color: 'var(--theme-green)',
  },
  [EChatListItemSwipeButtonType.Unstarred]: {
    text: (
      <>
        Убрать
        <br />
        из важных
      </>
    ),
    image: <IconActionStarCrossed24 color={'icon-inverted-default'} />,
    color: 'blue',
  },
};

type TChatListItemSwipeButtonProps = {
  type: EChatListItemSwipeButtonType;
  onClick(type: EChatListItemSwipeButtonType): void;
};

export const ChatListItemSwipeButton: React.FC<TChatListItemSwipeButtonProps> = ({ type, onClick }) => {
  const { text, color, image } = ButtonsInfo[type];

  const onClickHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick(type);
  };

  return (
    <button onClick={onClickHandler} className={classNames(styles['button'], styles[color])}>
      {image}
      <UIText3 color="text-inverted-default" whiteSpace="nowrap">
        {text}
      </UIText3>
    </button>
  );
};
